import styled, { CSSObject } from '@emotion/styled';
import { FC } from 'react';
import { QcsBox } from './QcsBox';

const TooltipContent = styled(QcsBox)(
  (): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    padding: '.5rem',
  })
);

interface Props {
  children: React.ReactNode;
}

export const QcsTooltipContent: FC<Props> = ({ children }) => {
  return <TooltipContent>{children}</TooltipContent>;
};
